import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, MaxValidator, Validators } from '@angular/forms';
import { BCBaseService } from 'src/app/services/bc-base.service';
import { PopupService } from 'src/app/services/popup.service';
import * as moment from 'moment';

@Component({
  selector: 'app-otp-dialog',
  templateUrl: './otp-dialog.component.html',
  styleUrls: ['./otp-dialog.component.scss']
})
export class OtpDialogComponent implements OnInit {

  otpControl = new FormControl('', [Validators.required, Validators.pattern(/^\d{6}$/)]); // OTP input control
  form: FormGroup;
  timerInterval: any;
  display: string;
  resettime: boolean = false;
  mobilenumber: any;
  Errormessage: any;
  showError: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<OtpDialogComponent>,
    private bc_baseService: BCBaseService, private formBuilder: FormBuilder, private popupService: PopupService) { }

  ngOnInit(): void {
    this.mobilenumber = this.data.number;
    this.initialValidators()
    this.timer()

  }
  initialValidators() {
    this.form = this.formBuilder.group({
      'otp': ['', [Validators.required, Validators.pattern("^[0-9]{6}$")]]
    })
  }
  // Close the dialog
  closeDialog() {
    this.dialogRef.close();
  }

  //................................................................Timer function...............................................................//

  timer() {
    let seconds: number = 2 * 90; // Initial timer duration in seconds (3 minutes)
    let textSec: string = '0';
    let statSec: number = 60;

    // Get the current time and add 3 minutes
    const targetTime = moment(new Date()).add(3, 'minutes');
    this.timerInterval = setInterval(() => {
      seconds--;


      if (statSec != 0) {
        statSec--;
      } else {
        statSec = 59;
      }

      if (statSec < 10) {
        textSec = '0' + statSec;
      } else {
        textSec = statSec.toString();
      }

      const minutes = Math.floor(seconds / 60);
      const prefix = minutes < 10 ? '0' : ''; // Prefix for minutes if less than 10

      this.display = `${prefix}${minutes}:${textSec}`;

      // Compare the current time with the target time
      if (moment().isSameOrAfter(targetTime) || seconds <= 0) {
        seconds = 0;
        this.display = '00:00'
        clearInterval(this.timerInterval);
        this.resettime = true;
      }
      if (seconds == 0) {
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  resend_OTP() {
    let Payload = {
      card_no: this.data.card_no,
    }
    this.bc_baseService.otp_send(Payload).subscribe((res) => {
      if (res.success) {
        this.resettime = false;
        this.timer()
      }
    })
  }

  // Submit OTP (for now just log it)
  submitOtp() {
    if (this.form.valid) {
      let Payload = {
        card_no: this.data.card_no,
        otp: this.form.value.otp
      }
      this.bc_baseService.otp_verification(Payload).subscribe((res) => {
        if (res.success) {
          this.dialogRef.close({
            "success": true,
            "message": "OTP verification success"
          });
        } else {
          this.showError = true
          this.Errormessage = 'Invalid OTP'
        }
      })
    }
  }
  errormessage() {
    this.showError = false
  }


  onPaste(event: any): void {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text/plain');
    const digits = pastedData
    const realDigits: any[] = digits.slice(0, 6);
    for (let i = 0; i < realDigits.length; i++) {
      const regex = /^[0-9.]+$/;
      if (!regex.test(realDigits[i])) {
        this.form.controls['otp'].setValue('');
        return
      } else {
        this.form.controls['otp'].setValue(realDigits);
      }
    }
  }


}
